export async function GetOpponent(): Promise<number> {
    await new Promise<number>((resolve) => {
        setTimeout(resolve, 2000);
    });
    return 1;
}
